export const assetPolarisDAO = {
  id: 16,
  height: 410745,
  data: {
    icon: "/imgs/icons/asset/polarisdao.svg",
    about:
      "PolarisDAO is a community-managed DAO with members from Web3 developers, artists, and venture capitalists. We are committed to advancing the NFTs market in the Dotsama ecosystem and identifying early investment opportunities. ARIS is PolarisDAO’s native token. It will be used for protocol governance and voting on expenditures of the PolarisDAO Vault (treasury).",
    links: [
      {
        name: "Twitter",
        url: "https://twitter.com/polaris_dao",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Medium",
        url: "https://medium.com/@polarisdao",
        icon: "/imgs/icons/link-medium.svg",
      },
      {
        name: "Gitbook",
        url: "https://polaris-dao.gitbook.io/polarisdao/",
        icon: "/imgs/icons/link-gitbook.svg",
      },
      {
        name: "Discord",
        url: "https://discord.gg/bayqHZ9akq",
        icon: "/imgs/icons/link-discord.svg",
      },
      {
        name: "CommonWealth",
        url: "https://commonwealth.im/polaris-dao/",
        icon: "/imgs/icons/link-commonwealth.svg",
      },
      {
        name: "Voting",
        url: "https://voting.opensquare.io/space/polarisdao",
        icon: "/imgs/icons/link-osn.svg",
      },
      {
        name: "Linktree",
        url: "https://linktr.ee/PolarisDAO",
        icon: "/imgs/icons/link-linktree.svg",
      },
    ],
    governances: [
      {
        spaceLogo: "/imgs/icons/asset/governance-polarisDAO.svg",
        spaceName: "PolarisDAO",
        projectName: "PolarisDAO",
        link: "https://voting.opensquare.io/space/polarisdao",
      },
    ],
  },
};
